import React from 'react';

// §3 眉毛 — 双眉/豆豆/焰眉 (eyebrow-style) + 眉毛颜色 (brow-color)
// HOOD mode
// Extracted verbatim from the original Hood.js renderer; element order is
// significant (SVG z-order, later = painted on top) — do not reorder.

export function EyebrowSection({ config, parts }) {
  return (
    <>
{config['eyebrow-style'] === 'default' ? <g id="eyebrow-default">
 <path className={"hood-" + config['brow-color']} d={parts['brow-color_c'] || ''}/>
 <path className={"hood-" + config['brow-color']} d={parts['brow-color_c_2'] || ''}/>
 <path className="clear str_222222_50" d={parts['clear-path-176'] || ''}/>
 <path className="clear str_222222_25_125_75" d={parts['clear-path-177'] || ''}/>
 <path className={"hood-" + config['brow-color'] + " str_222222_50"} d={parts['brow-color_c_3'] || ''}/>
 <path className="clear str_222222_25_125_75" d={parts['clear-path-179'] || ''}/>
</g> : <g/>}
{config['eyebrow-style'] === 'frame' ? <g id="eyebrow-frame">
 <path className="clear str_332C2B_25_50_75" d={parts['clear-path-180'] || ''}/>
 <path className={"hood-" + config['brow-color'] + " str_222222_50"} d={parts['brow-color_c_6'] || ''}/>
 <path className="clear str_332C2B_25_50_75" d={parts['clear-path-186'] || ''}/>
 <path className={"hood-" + config['brow-color'] + " str_222222_50"} d={parts['brow-color_c_5'] || ''}/>
 <path className="clear str_332C2B_25_50_75" d={parts['clear-path-184'] || ''}/>
 <path className={"hood-" + config['brow-color'] + " str_222222_50"} d={parts['brow-color_c_6'] || ''}/>
 <path className="clear str_332C2B_25_50_75" d={parts['clear-path-186'] || ''}/>
</g> : <g/>}
{config['eyebrow-style'] === 'dou' ? <g id="eyebrow-dou">
 <path className={"hood-" + config['brow-color'] + " str_332C2B_50"} d={parts['brow-color_c_7'] || ''}/>
 <path className="clear str_332C2B_20_40_60" d={parts['clear-path-188'] || ''}/>
 <path className={"hood-" + config['brow-color'] + " str_332C2B_50"} d={parts['brow-color_c_8'] || ''}/>
 <path className="clear str_332C2B_20_40_60" d={parts['clear-path-190'] || ''}/>
</g> : <g/>}
    </>
  );
}
